














import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import notificationService from '@/services/notificationService';
import { DxList } from 'devextreme-vue';
import rawmaterialsRepos from '@/services/rawmaterialsRepository';
import RawMaterialsCompositionCard from '@/modules/articles/components/ArticleRawMaterialsCompositionCard.vue';
import SellingpriceCompositionCard from '@/modules/articles/components/ArticleSellingpriceCompositionCard.vue';
import ArticleBillOfMaterialsCard from '@/modules/articles/components/ArticleBillOfMaterialsCard.vue';
import { ArticlesClient, UpdateArticleBillOfMaterialsCommand, Variant, Article } from '@/data/web-api-client';

@Component({
  components: {
    RawMaterialsCompositionCard,
    SellingpriceCompositionCard,
    ArticleBillOfMaterialsCard,
    DxList,
  },
})
export default class CompositionCard extends Vue {
  @Prop({ required: true })
  public value!: Article;
  public rawmaterials: any[] = [];
  public selectedVariant?: Variant | null = null;

  editableValue: Article | null = null;
  selectedVariantName: any[] = [];

  public async mounted() {
    this.editableValue = Object.assign(new Article(), this.value);
    if (this.value.variants && this.value.variants.length > 0) {
      this.selectedVariant = this.value.variants[0];
    }
    this.loadRawmaterials();
  }

  public async saveVariant() {
    try {
      if (!this.selectedVariant) {
        return;
      }

      const result = await new ArticlesClient(undefined, this.$axios).updateVariant(this.value.id!, this.selectedVariant.name!, this.selectedVariant);

      this.$emit('input', result);
      this.setSelectedVariant();
      notificationService.saved();
    } catch (err) {
      notificationService.showAxiosError(err);
    }
  }

  public async saveBillOfMaterial() {
    try {
      const command = {
        id: this.value.id ? this.value.id : '',
        billOfMaterials: this.value.billOfMaterials,
      } as UpdateArticleBillOfMaterialsCommand;

      const result = await new ArticlesClient(undefined, this.$axios).updateBillOfMaterials(this.value.id ? this.value.id : '', command);

      this.$emit('input', result);
      notificationService.saved();
      this.selectedVariant = null;
      setTimeout(() => {
        if (this.value.type === 1 && this.value.variants && this.value.variants.length > 0) {
          this.selectedVariant = this.value.variants[0];
        }
      }, 200);
    } catch (err) {
      notificationService.showAxiosError(err);
    }
  }

  async add() {
    const name = prompt(this.$t('objects.articles.EnterNameMsg') as string, '');

    if (this.value && name && name !== '') {
      const result = await new ArticlesClient(undefined, this.$axios).addVariant(this.value.id!, name);

      this.$emit('input', result);
      Object.assign(this.editableValue as Article, result);
      notificationService.saved();
    }
  }

  async changeName() {
    const name = prompt(this.$t('objects.articles.EnterNameMsg') as string, '');

    if (name && name !== '') {
      const data = Object.assign({}, this.selectedVariant);

      data.name = name;

      const result = await new ArticlesClient(undefined, this.$axios).updateVariant(this.value.id!, this.selectedVariantName[0], data);

      this.$emit('input', result);
      Object.assign(this.editableValue as Article, result);
      this.selectedVariant = null;
      notificationService.saved();
    }
  }

  confirmDelete(e: any) {
    const self = this;

    e.cancel = new Promise(async (resolve, reject) => {
      const confirmed = window.confirm(self.$t('messages.AreYouSure') as string);

      if (!confirmed) {
        return;
      }

      const result = await new ArticlesClient(undefined, this.$axios).deleteVariant(self.value.id!, e.itemData.name);

      self.$emit('input', result);
      Object.assign(this.editableValue as Article, result);
      notificationService.saved();
      this.selectedVariant = null;
      resolve(!confirmed);
    });
  }

  async loadRawmaterials() {
    try {
      this.rawmaterials = (await rawmaterialsRepos.get()).data;
    } catch {
      notificationService.failedToLoad();
    }
  }

  setSelectedVariant() {
    setTimeout(() => {
      if (this.selectedVariantName.length === 0) {
        return;
      }
      if (this.value.variants && this.value.variants.length > 0) {
        this.selectedVariant = this.value.variants[0];
      }
    }, 150);
  }

  get projecttypes() {
    const catalog = this.$store.getters['catalogs/list']('ProjectTypes');
    return catalog ? catalog.values : [];
  }

  get settings() {
    return this.$store.getters['settings/data'];
  }

  @Watch('selectedVariantName', { deep: true })
  onSelectionChange() {
    this.setSelectedVariant();
  }
}
